import React, { useEffect, useMemo, useState } from "react";
import { safeLocaleCompare } from "../../../core/methods/sorterMethods";
import { ColumnsType } from "antd/es/table";
import Datatable from "../../../core/common/dataTable";
import {
  dummy_managerFilteredProgram,
  dummy_managerPrograms,
  dummydata_verifier,
} from "../../../core/data/js/dummy-data";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import { all_routes } from "../../router/all_routes";
import { ErrorType, PaginationType } from "../../../types/common-type";
import { toast } from "react-toastify";
import DynamicSingleSelect from "../reusable/DynamicSingleSelect";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { useNavigate, useParams } from "react-router";
import { useAuth } from "../../../core/context/useAuthContext";
import Loading from "../../../core/common/custom-loading/Loading";
import UserDetailsSection from "./UserDetailsSection";
import useLocalStorage from "../../../core/customhook/hooks/useLocalStorage";
import { getSearchableHeader } from "../../../core/utils/getSearchableHeader";
import { cellWidth } from "../../../core/methods/tableCellWidth";

// breadcrumb data
const breadcrumbItem = [
  { label: "Manage Manager" },
  { label: "Manage Programs" },
];

interface FilterType {
  organization: string;
  project: string;
  location: string;
  program: string;
  department: string;
}

const initialFilter = {
  organization: "",
  project: "",
  location: "",
  program: "",
  department: "",
};

const ManageAssignedManagerPrograms = () => {
  const { auth } = useAuth();
  const { managerId } = useParams();
  const { getLocalStorage } = useLocalStorage();
  const navigate = useNavigate();

  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [currentManagerData, setCurrentManagerData] = useState<any>(null);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  const [selectedDeleteItem, setSelectedDeleteItem] = useState<string | null>(
    null,
  );

  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 1000, // limit of records
    total: 0,
  });

  type InviteItem = any;
  const filteredData = (Array.isArray(allItemList) ? allItemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );

  // ---- API ----
  const { callApi, loading } = useApi<any>(
    webservice_url.assign_program_to_manager,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );
  const { callApi: deleteProgramApi, loading: loading_delete } = useApi<any>(
    "",
    {
      method: "DELETE",
      autoCall: false,
      handleGlobalError: false,
    },
  );
  const { callApi: getAssignedProgramsAPI, loading: loading_getProgram } =
    useApi<any>(webservice_url.get_assigned_programs_to_manager, {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    });

  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Organization",
        "org_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "org_name",
      key: "org_name",
      // onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "org_name"),
    },
    {
      title: getSearchableHeader(
        "Account",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      // onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "project_name"),
    },
    // {
    //     title: "Location",
    //     dataIndex: "location",
    //     key: "location",
    //     // onCell: () => cellWidth(190),
    //     sorter: (a, b) => safeLocaleCompare(a, b, "location"),
    // },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      // onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "program_name"),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      // onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "department_name"),
    },
    {
      title: "Action",
      dataIndex: "",
      align: "center",
      render: (text: string, record: any) => {
        return (
          <button
            type="button"
            className="btn btn-sm btn-danger"
            disabled={loading || loading_delete}
            onClick={() => {
              const id = record?.manager_profile_map_id ?? "";
              handleDeleteProgram(id);

              setSelectedDeleteItem(id);
            }}
          >
            {selectedDeleteItem == record?.manager_profile_map_id ? (
              "Deleting..."
            ) : (
              <>
                <i className="ti ti-trash"></i> Delete
              </>
            )}
            {/* <i className="ti ti-trash"></i> */}
          </button>
        );
      },
    },
  ];

  // ======== fetch all managers =========
  const fetchData = async () => {
    try {
      const res = await getAssignedProgramsAPI({
        page: pagination?.current ?? 1,
        limit: pagination?.pageSize ?? 10,
        manager_id: managerId ?? "",
        // manager_id: "11ebd52b-af44-4cc2-87d1-592f090c2148"
      });
      if (res?.success) {
        const data = res?.data?.rows || [];
        setAllItemList(data);

        setPagination((prev) => ({
          ...prev,
          total: res?.data?.pagination?.totalRecords || 0,
        }));
      }
    } catch (error: any) {
      console.error(error?.response);
    }
  };

  useEffect(() => {
    if (!managerId) return;
    fetchData();
  }, [managerId, pagination?.current, pagination?.pageSize]);

  // handleTableChange
  const handleTableChange = (pgConfig: any) => {
    if (
      pgConfig.current !== pagination.current ||
      pgConfig.pageSize !== pagination.pageSize
    ) {
      setPagination((prev) => ({
        ...prev,
        current: pgConfig.current,
        pageSize: pgConfig.pageSize,
      }));
    }
  };
  // ======== / fetch all managers =========

  // handleDelete
  const handleDeleteProgram = async (id: string) => {
    try {
      // return;
      const res = await deleteProgramApi(
        undefined,
        `${webservice_url.delete_program_from_manager}/${id}`,
      );
      if (res?.success) {
        toast.success(res?.message || "Program deleted successfully");
        fetchData();
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setSelectedDeleteItem(null);
    }
  };

  useEffect(() => {
    const storedData = getLocalStorage("admin_selected_manager");
    if (!storedData) return;
    setCurrentManagerData(storedData);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* PageBreadcrumb */}
        <PageBreadcrumb
          title="Manage Programs"
          breadcrumbs={breadcrumbItem}
          showBackButton={true}
          backRoute={all_routes.admin_addManager}
          // showExport={true}
        />
        {/* /PageBreadcrumb */}

        {/* manager details */}
        <UserDetailsSection userDetails={currentManagerData} />
        {/* Table  */}
        <div className="card mt-3" style={{ minHeight: "250px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0">Added LOBs</h5>
              <small className="text-muted">
                LOBs currently assigned to this manager
              </small>
            </div>

            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={() =>
                navigate(all_routes.add_more_lob_to_manager, {
                  state: currentManagerData,
                })
              }
            >
              <i className="ti ti-plus" />
              Add More LOB
            </button>
          </div>

          <div className="card-body">
            {loading_getProgram ? (
              <Loading />
            ) : (
              <Datatable
                dataSource={filteredData}
                columns={columns}
                Selection={false}
                rowKey="manager_id"
                pagination={pagination}
                handleTableChange={handleTableChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAssignedManagerPrograms;
